export default __webpack_public_path__ + "static/media/typescript.78aa7804.svg";